import clsx from "clsx";
import { ManIcon, WomenIcon } from "@/shared/icons";
import { GenderEnum } from "@/domains/createCharacter/constants/general";

type Props = {
  value: GenderEnum;
  onChange: (gender: GenderEnum) => void;
};

export default function CreateCharacterGender({ value, onChange }: Props) {
  return (
    <div className="bg-dark-800 shrink-0 gap-px flex justify-between items-center rounded-xl h-13.5 pl-4 pr-2">
      <div className="font-bold mr-auto text-15">Выберите пол:</div>
      <div className="flex gap-1.5 ml-auto">
        <button
          type="button"
          className={clsx(
            "btn gap-2 h-9 px-3 normal-case text-base",
            value === GenderEnum.Male ? "variant-solid-gradient" : "variant-solid variant-matched",
          )}
          onClick={() => onChange(GenderEnum.Male)}
        >
          <ManIcon size={20} />
          <span>Мужской</span>
        </button>
        <button
          type="button"
          className={clsx(
            "btn gap-2 h-9 px-3 normal-case text-base",
            value === GenderEnum.Female
              ? "variant-solid-gradient"
              : "variant-solid variant-matched",
          )}
          onClick={() => onChange(GenderEnum.Female)}
        >
          <WomenIcon size={20} />
          <span>Женский</span>
        </button>
      </div>
    </div>
  );
}
